import { createApp } from 'vue';
import { message } from 'ant-design-vue';
import App from './App.vue';
// 测试qrcode 组件就把这里的注释打开
// import App from './DevPreview.vue';
import { setErrorNotifier } from '@/request/axios';
import '@/assets/styles/global.scss';

// 独立 app 注入错误 toast，请求层 onShowError 回调通过它弹出 message.error
setErrorNotifier((m) => message.error(m));

const app = createApp(App);

app.mount('#app');
